<template>
  <div ref="stage5" class="stage5-mob" :class="[{white: getIsWhiteBg}]">
    <div class="text-wrapper">
      <div class="text-wrapper__line icon">
        <p>
          Ready to
        </p>
        <img src="@/assets/images/app_icon.png" alt="">
      </div>
      <p class="text-wrapper__line m-l"><span>revolutio-</span></p>
      <p class="text-wrapper__line m-l"><span>nize</span></p>
      <p class="text-wrapper__line">your</p>
      <p class="text-wrapper__line ">business?</p>

    </div>

    <a href="https://inch.health/contact" target="_blank" class="btn hover-get-in-touch"
       onclick="gtag('event', 'click_btn', {'btn_name': 'Get in touch'})">
      <p>Get in touch</p>
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-opacity="0.6" fill-rule="evenodd" clip-rule="evenodd"
              d="M1.48491 0.496048C1.2064 0.496045 0.980615 0.717959 0.980611 0.991707C0.980608 1.26546 1.20639 1.48737 1.4849 1.48738L12.2878 1.4875L0.864033 12.9624C0.669254 13.1581 0.673149 13.4715 0.872731 13.6624C1.07231 13.8534 1.39201 13.8495 1.58678 13.6539L12.9837 2.20599L12.9843 13.0061C12.9843 13.2798 13.2101 13.5017 13.4887 13.5017C13.7672 13.5017 13.9929 13.2798 13.9929 13.006L13.9922 0.991825L13.9922 0.496194L13.4879 0.496189L1.48491 0.496048Z"
              fill="white"/>
      </svg>
    </a>

    <p class="text">Get in touch with us now and take the first step towards a more efficient, innovative, and
      engaging workplace with <b>SPEECHki!</b>
    </p>
    <p class="text">Elevate your business with <b>SPEECHki</b> – your B2B gateway to the world of Augmented Reality
      solutions, created by <a class="brand-link" href="https://inch.health/" target="_blank">INCH.Health</a>.
    </p>
    <div class="app-btn-wrapper">
      <a onclick="gtag('event', 'click_btn', {'btn_name': 'Get it on Google play'})" class="hover-app-download" href="https://play.google.com/store/apps/details?id=com.speechki.app&hl=uk&gl=US"
         target="_blank">
        <svg width="167" height="48" viewBox="0 0 167 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="bg-black"
                d="M160 48H6.15385C2.77077 48 0 45.2985 0 42V6C0 2.7015 2.77077 -1.90735e-06 6.15385 -1.90735e-06H160C163.383 -1.90735e-06 166.154 2.7015 166.154 6V42C166.154 45.2985 163.383 48 160 48Z"
                fill="black"/>
          <path class="bg-hover"
                d="M160 48H6.15385C2.77077 48 0 45.2985 0 42V6C0 2.7015 2.77077 -1.90735e-06 6.15385 -1.90735e-06H160C163.383 -1.90735e-06 166.154 2.7015 166.154 6V42C166.154 45.2985 163.383 48 160 48Z"
                fill="url(#paint0_linear_307_884)"/>
          <path
              d="M11.9204 9.0465C11.5588 9.4155 11.3496 9.99 11.3496 10.734V37.272C11.3496 38.016 11.5588 38.5905 11.9204 38.9595L12.0096 39.0405L27.2619 24.1755V23.8245L12.0096 8.9595L11.9204 9.0465Z"
              fill="white"/>
          <path
              d="M34.1869 29.133L29.1084 24.1755V23.8245L34.193 18.867L34.3069 18.9315L40.3284 22.272C42.0469 23.22 42.0469 24.78 40.3284 25.734L34.3069 29.0685L34.1869 29.133Z"
              fill="white"/>
          <path
              d="M33.3838 29.9916L28.1853 24.9231L12.8438 39.8826C13.4145 40.4676 14.3453 40.5381 15.4037 39.9531L33.3838 29.9916Z"
              fill="white"/>
          <path
              d="M33.3838 18.0084L15.4037 8.04691C14.3453 7.46791 13.4145 7.5384 12.8438 8.1234L28.1853 23.0769L33.3838 18.0084Z"
              fill="white"/>
          <path
              d="M58.3601 12.2925C58.3601 13.2945 58.0524 14.097 57.4463 14.6955C56.7494 15.405 55.8417 15.762 54.7294 15.762C53.6663 15.762 52.7586 15.399 52.014 14.6835C51.2678 13.9575 50.8955 13.0665 50.8955 12C50.8955 10.9335 51.2678 10.0425 52.014 9.32249C52.7586 8.60099 53.6663 8.23799 54.7294 8.23799C55.2586 8.23799 55.7632 8.34449 56.2447 8.54249C56.7247 8.74199 57.1155 9.01199 57.3986 9.34499L56.7555 9.97799C56.2617 9.40949 55.5894 9.12899 54.7294 9.12899C53.954 9.12899 53.2817 9.39299 52.7109 9.92549C52.1463 10.4595 51.8632 11.151 51.8632 12C51.8632 12.849 52.1463 13.5465 52.7109 14.0805C53.2817 14.607 53.954 14.877 54.7294 14.877C55.5524 14.877 56.2447 14.607 56.7909 14.0745C57.1509 13.722 57.3555 13.236 57.4094 12.615H54.7294V11.748H58.3047C58.3478 11.9355 58.3601 12.117 58.3601 12.2925Z"
              fill="white" stroke="white" stroke-width="0.16" stroke-miterlimit="10"/>
          <path
              d="M64.0329 9.28648H60.6744V11.5665H63.7021V12.4335H60.6744V14.7135H64.0329V15.597H59.7236V8.40298H64.0329V9.28648Z"
              fill="white" stroke="white" stroke-width="0.16" stroke-miterlimit="10"/>
          <path d="M68.0352 15.597H67.0844V9.28648H65.0244V8.40298H70.0967V9.28648H68.0352V15.597Z" fill="white"
                stroke="white" stroke-width="0.16" stroke-miterlimit="10"/>
          <path d="M73.7676 15.597V8.40298H74.7168V15.597H73.7676Z" fill="white" stroke="white"
                stroke-width="0.16" stroke-miterlimit="10"/>
          <path d="M78.9248 15.597H77.9817V9.28648H75.9141V8.40298H80.9925V9.28648H78.9248V15.597Z" fill="white"
                stroke="white" stroke-width="0.16" stroke-miterlimit="10"/>
          <path
              d="M90.5959 14.6715C89.8682 15.399 88.9666 15.762 87.8912 15.762C86.8097 15.762 85.9082 15.399 85.1805 14.6715C84.4543 13.9455 84.0928 13.0545 84.0928 12C84.0928 10.9455 84.4543 10.0545 85.1805 9.32849C85.9082 8.60099 86.8097 8.23799 87.8912 8.23799C88.9605 8.23799 89.862 8.60099 90.5897 9.33449C91.322 10.0665 91.6836 10.9515 91.6836 12C91.6836 13.0545 91.322 13.9455 90.5959 14.6715ZM85.8835 14.0685C86.4312 14.607 87.0974 14.877 87.8912 14.877C88.6789 14.877 89.3512 14.607 89.8928 14.0685C90.4389 13.53 90.7158 12.8385 90.7158 12C90.7158 11.1615 90.4389 10.47 89.8928 9.93149C89.3512 9.39299 88.6789 9.12299 87.8912 9.12299C87.0974 9.12299 86.4312 9.39299 85.8835 9.93149C85.3374 10.47 85.0605 11.1615 85.0605 12C85.0605 12.8385 85.3374 13.53 85.8835 14.0685Z"
              fill="white" stroke="white" stroke-width="0.16" stroke-miterlimit="10"/>
          <path
              d="M93.0166 15.597V8.40298H94.1704L97.7581 13.998H97.7997L97.7581 12.615V8.40298H98.7074V15.597H97.7166L93.9597 9.72598H93.9181L93.9597 11.115V15.597H93.0166Z"
              fill="white" stroke="white" stroke-width="0.16" stroke-miterlimit="10"/>
          <path
              d="M83.8584 26.103C80.9677 26.103 78.6061 28.248 78.6061 31.2075C78.6061 34.143 80.9677 36.3105 83.8584 36.3105C86.7553 36.3105 89.1169 34.143 89.1169 31.2075C89.1169 28.248 86.7553 26.103 83.8584 26.103ZM83.8584 34.3005C82.2723 34.3005 80.9077 33.024 80.9077 31.2075C80.9077 29.367 82.2723 28.113 83.8584 28.113C85.4446 28.113 86.8153 29.367 86.8153 31.2075C86.8153 33.024 85.4446 34.3005 83.8584 34.3005ZM72.3984 26.103C69.5015 26.103 67.1461 28.248 67.1461 31.2075C67.1461 34.143 69.5015 36.3105 72.3984 36.3105C75.2938 36.3105 77.6507 34.143 77.6507 31.2075C77.6507 28.248 75.2938 26.103 72.3984 26.103ZM72.3984 34.3005C70.8107 34.3005 69.4415 33.024 69.4415 31.2075C69.4415 29.367 70.8107 28.113 72.3984 28.113C73.9846 28.113 75.3492 29.367 75.3492 31.2075C75.3492 33.024 73.9846 34.3005 72.3984 34.3005ZM58.7615 27.6675V29.8365H64.0738C63.9184 31.0485 63.503 31.9395 62.8661 32.5605C62.0907 33.3105 60.883 34.143 58.7615 34.143C55.4923 34.143 52.9323 31.5705 52.9323 28.383C52.9323 25.1955 55.4923 22.623 58.7615 22.623C60.5292 22.623 61.8154 23.2965 62.7646 24.1695L64.3323 22.641C63.0046 21.405 61.2384 20.4555 58.7615 20.4555C54.2784 20.4555 50.5107 24.012 50.5107 28.383C50.5107 32.754 54.2784 36.3105 58.7615 36.3105C61.1846 36.3105 63.0046 35.5365 64.4354 34.0845C65.9015 32.655 66.3584 30.645 66.3584 29.022C66.3584 28.518 66.3154 28.0545 66.2384 27.6675H58.7615ZM114.525 29.349C114.092 28.2075 112.758 26.103 110.041 26.103C107.349 26.103 105.108 28.1715 105.108 31.2075C105.108 34.0665 107.326 36.3105 110.3 36.3105C112.705 36.3105 114.092 34.881 114.663 34.0485L112.878 32.889C112.283 33.738 111.472 34.3005 110.3 34.3005C109.135 34.3005 108.3 33.78 107.765 32.754L114.766 29.9295L114.525 29.349ZM107.386 31.0485C107.326 29.0805 108.954 28.0725 110.12 28.0725C111.034 28.0725 111.809 28.518 112.068 29.1555L107.386 31.0485ZM101.695 36H103.997V21H101.695V36ZM97.9261 27.24H97.8492C97.3323 26.643 96.3461 26.103 95.0969 26.103C92.4753 26.103 90.0784 28.347 90.0784 31.224C90.0784 34.0845 92.4753 36.3105 95.0969 36.3105C96.3461 36.3105 97.3323 35.766 97.8492 35.151H97.9261V35.883C97.9261 37.8345 96.8569 38.883 95.1323 38.883C93.7261 38.883 92.8538 37.893 92.4938 37.0605L90.4923 37.875C91.0692 39.228 92.5969 40.893 95.1323 40.893C97.8307 40.893 100.108 39.345 100.108 35.5785V26.4135H97.9261V27.24ZM95.2938 34.3005C93.7077 34.3005 92.38 33.006 92.38 31.224C92.38 29.4255 93.7077 28.113 95.2938 28.113C96.8569 28.113 98.0892 29.4255 98.0892 31.224C98.0892 33.006 96.8569 34.3005 95.2938 34.3005ZM125.3 21H119.795V36H122.091V30.3165H125.3C127.849 30.3165 130.349 28.518 130.349 25.6575C130.349 22.7985 127.843 21 125.3 21ZM125.36 28.23H122.091V23.0865H125.36C127.074 23.0865 128.052 24.474 128.052 25.6575C128.052 26.8185 127.074 28.23 125.36 28.23ZM139.549 26.0745C137.891 26.0745 136.166 26.7885 135.457 28.371L137.494 29.2035C137.932 28.371 138.738 28.101 139.591 28.101C140.781 28.101 141.989 28.7985 142.008 30.03V30.1875C141.592 29.9535 140.703 29.607 139.609 29.607C137.415 29.607 135.18 30.7845 135.18 32.982C135.18 34.992 136.977 36.2865 138.997 36.2865C140.541 36.2865 141.394 35.607 141.929 34.8165H142.008V35.976H144.225V30.222C144.225 27.5625 142.188 26.0745 139.549 26.0745ZM139.272 34.2945C138.521 34.2945 137.475 33.9315 137.475 33.024C137.475 31.863 138.78 31.4175 139.909 31.4175C140.92 31.4175 141.394 31.635 142.008 31.9215C141.828 33.3105 140.601 34.2945 139.272 34.2945ZM152.301 26.403L149.663 32.9055H149.585L146.857 26.403H144.381L148.48 35.49L146.141 40.5465H148.54L154.855 26.403H152.301ZM131.611 36H133.912V21H131.611V36Z"
              fill="white"/>
          <defs>
            <linearGradient id="paint0_linear_307_884" x1="83.0769" y1="48" x2="47.5" y2="1.00333e-06"
                            gradientUnits="userSpaceOnUse">
              <stop stop-color="#5C2482"/>
              <stop offset="1" stop-color="#C42F2D"/>
            </linearGradient>
          </defs>
        </svg>
      </a>
      <a onclick="gtag('event', 'click_btn', {'btn_name': 'Download on App Store'})" class="hover-app-download" href="https://apps.apple.com/ua/app/speechki-ar-platform/id1434538222?l=uk"
         target="_blank">
        <svg width="167" height="48" viewBox="0 0 167 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="bg-black"
                d="M165.385 42.4644C165.385 45.0223 163.27 47.0943 160.653 47.0943H5.81478C3.19976 47.0943 1.07715 45.0223 1.07715 42.4644V5.5417C1.07715 2.98493 3.19976 0.90567 5.81478 0.90567H160.652C163.27 0.90567 165.384 2.98493 165.384 5.5417L165.385 42.4644Z"
                fill="black"/>
          <path class="bg-hover"
                d="M160 48H6.15385C2.77077 48 0 45.2985 0 42V6C0 2.7015 2.77077 -1.90735e-06 6.15385 -1.90735e-06H160C163.383 -1.90735e-06 166.154 2.7015 166.154 6V42C166.154 45.2985 163.383 48 160 48Z"
                fill="url(#paint0_linear_307_884)"/>
          <path
              d="M37.2352 23.7408C37.1995 19.8732 40.4832 17.9916 40.6333 17.904C38.7736 15.2604 35.8912 14.8992 34.8782 14.8704C32.4573 14.622 30.109 16.2828 28.8758 16.2828C27.6179 16.2828 25.7189 14.8944 23.6721 14.9352C21.0382 14.9748 18.5742 16.4616 17.2229 18.7704C14.4339 23.478 16.5139 30.396 19.1859 34.2012C20.5226 36.0648 22.0844 38.1456 24.1287 38.0724C26.1287 37.992 26.8758 36.8292 29.2893 36.8292C31.6807 36.8292 32.3822 38.0724 34.4672 38.0256C36.6136 37.992 37.965 36.1536 39.2549 34.2732C40.7995 32.1372 41.4198 30.0336 41.4444 29.9256C41.3939 29.9088 37.2758 28.3764 37.2352 23.7408Z"
              fill="white"/>
          <path
              d="M33.2967 12.3672C34.3724 11.0556 35.1084 9.2712 34.9041 7.4604C33.3472 7.5276 31.4001 8.5104 30.2789 9.7932C29.2869 10.9236 28.4007 12.7764 28.6296 14.5188C30.3786 14.646 32.1742 13.6584 33.2967 12.3672Z"
              fill="white"/>
          <path
              d="M60.5243 12.0108C60.5243 13.4232 60.0899 14.4864 59.2222 15.2004C58.4185 15.8592 57.2763 16.1892 55.7969 16.1892C55.0634 16.1892 54.4357 16.158 53.9102 16.0956V8.37841C54.5957 8.27041 55.3342 8.21521 56.1317 8.21521C57.5409 8.21521 58.6031 8.51401 59.3194 9.11161C60.1219 9.78721 60.5243 10.7532 60.5243 12.0108ZM59.1643 12.0456C59.1643 11.13 58.9157 10.428 58.4185 9.93841C57.9212 9.45001 57.1951 9.20521 56.2388 9.20521C55.8326 9.20521 55.4868 9.23161 55.2 9.28681V15.1536C55.3588 15.1776 55.6492 15.1884 56.0714 15.1884C57.0585 15.1884 57.8203 14.9208 58.3569 14.3856C58.8935 13.8504 59.1643 13.0704 59.1643 12.0456Z"
              fill="white"/>
          <path
              d="M67.7352 13.2444C67.7352 14.1144 67.4804 14.8272 66.9709 15.3864C66.4367 15.9612 65.729 16.248 64.8454 16.248C63.9937 16.248 63.3155 15.9732 62.8097 15.4212C62.305 14.8704 62.0527 14.1756 62.0527 13.338C62.0527 12.462 62.3124 11.7432 62.8343 11.1852C63.3561 10.6272 64.0577 10.3476 64.9414 10.3476C65.793 10.3476 66.4774 10.6224 66.9955 11.1732C67.4878 11.7084 67.7352 12.3996 67.7352 13.2444ZM66.3974 13.2852C66.3974 12.7632 66.2817 12.3156 66.0515 11.9424C65.7807 11.4912 65.3955 11.2656 64.8946 11.2656C64.3764 11.2656 63.9826 11.4912 63.7118 11.9424C63.4804 12.3156 63.366 12.7704 63.366 13.308C63.366 13.83 63.4817 14.2776 63.7118 14.6508C63.9912 15.102 64.3801 15.3276 64.8823 15.3276C65.3746 15.3276 65.761 15.0984 66.0392 14.6388C66.278 14.2584 66.3974 13.8072 66.3974 13.2852Z"
              fill="white"/>
          <path
              d="M77.4042 10.4628L75.5888 16.1196H74.4073L73.6553 13.6632C73.4645 13.05 73.3094 12.4404 73.1888 11.8356H73.1654C73.0534 12.4572 72.8984 13.0656 72.699 13.6632L71.9002 16.1196H70.7051L68.998 10.4628H70.3236L70.9796 13.152C71.1383 13.788 71.2688 14.394 71.3734 14.9676H71.3968C71.4928 14.4948 71.6516 13.8924 71.8756 13.164L72.699 10.464H73.75L74.539 13.1064C74.7297 13.7508 74.8848 14.3712 75.0042 14.9688H75.0399C75.1273 14.3868 75.259 13.7664 75.4337 13.1064L76.1377 10.464H77.4042V10.4628Z"
              fill="white"/>
          <path
              d="M84.0914 16.1196H82.8015V12.8796C82.8015 11.8812 82.4126 11.382 81.6323 11.382C81.2495 11.382 80.9406 11.5188 80.7006 11.7936C80.4631 12.0684 80.3425 12.3924 80.3425 12.7632V16.1184H79.0526V12.0792C79.0526 11.5824 79.0366 11.0436 79.0059 10.4604H80.1394L80.1997 11.3448H80.2354C80.3855 11.07 80.6095 10.8432 80.9037 10.662C81.2532 10.4508 81.6446 10.344 82.0729 10.344C82.6145 10.344 83.0649 10.5144 83.4231 10.8564C83.8686 11.2752 84.0914 11.9004 84.0914 12.7308V16.1196Z"
              fill="white"/>
          <path d="M87.648 16.1196H86.3594V7.8672H87.648V16.1196Z" fill="white"/>
          <path
              d="M95.242 13.2444C95.242 14.1144 94.9873 14.8272 94.4777 15.3864C93.9436 15.9612 93.2347 16.248 92.3522 16.248C91.4993 16.248 90.8211 15.9732 90.3165 15.4212C89.8119 14.8704 89.5596 14.1756 89.5596 13.338C89.5596 12.462 89.8193 11.7432 90.3411 11.1852C90.863 10.6272 91.5645 10.3476 92.447 10.3476C93.2999 10.3476 93.983 10.6224 94.5023 11.1732C94.9946 11.7084 95.242 12.3996 95.242 13.2444ZM93.903 13.2852C93.903 12.7632 93.7873 12.3156 93.5571 11.9424C93.2876 11.4912 92.9011 11.2656 92.4014 11.2656C91.882 11.2656 91.4882 11.4912 91.2186 11.9424C90.9873 12.3156 90.8728 12.7704 90.8728 13.308C90.8728 13.83 90.9885 14.2776 91.2186 14.6508C91.498 15.102 91.887 15.3276 92.3891 15.3276C92.8814 15.3276 93.2666 15.0984 93.5448 14.6388C93.7848 14.2584 93.903 13.8072 93.903 13.2852Z"
              fill="white"/>
          <path
              d="M101.485 16.1196H100.327L100.231 15.468H100.195C99.7986 15.9876 99.2337 16.248 98.5001 16.248C97.9524 16.248 97.5094 16.0764 97.1758 15.7356C96.8731 15.426 96.7217 15.0408 96.7217 14.5836C96.7217 13.8924 97.0171 13.3656 97.6115 13.0008C98.2048 12.636 99.0392 12.4572 100.114 12.4656V12.36C100.114 11.6148 99.7124 11.2428 98.9088 11.2428C98.3364 11.2428 97.8318 11.3832 97.3961 11.6616L97.134 10.836C97.6731 10.5108 98.3389 10.3476 99.1241 10.3476C100.64 10.3476 101.401 11.1276 101.401 12.6876V14.7708C101.401 15.336 101.429 15.786 101.485 16.1196ZM100.146 14.1756V13.3032C98.7229 13.2792 98.0115 13.6596 98.0115 14.4432C98.0115 14.7384 98.0928 14.9592 98.2589 15.1068C98.4251 15.2544 98.6368 15.3276 98.8891 15.3276C99.1721 15.3276 99.4368 15.24 99.678 15.066C99.9204 14.8908 100.069 14.6688 100.125 14.3964C100.138 14.3352 100.146 14.2608 100.146 14.1756Z"
              fill="white"/>
          <path
              d="M108.814 16.1196H107.669L107.609 15.2112H107.573C107.208 15.9024 106.585 16.248 105.71 16.248C105.011 16.248 104.429 15.9804 103.967 15.4452C103.506 14.91 103.275 14.2152 103.275 13.362C103.275 12.4464 103.525 11.7048 104.027 11.1384C104.514 10.6104 105.109 10.3464 105.818 10.3464C106.597 10.3464 107.142 10.602 107.453 11.1144H107.477V7.8672H108.768V14.5956C108.768 15.1464 108.783 15.654 108.814 16.1196ZM107.477 13.734V12.7908C107.477 12.6276 107.465 12.4956 107.442 12.3948C107.369 12.0924 107.213 11.838 106.975 11.6328C106.735 11.4276 106.446 11.3244 106.112 11.3244C105.631 11.3244 105.254 11.5104 104.978 11.8836C104.703 12.2568 104.564 12.7332 104.564 13.3152C104.564 13.8744 104.696 14.328 104.96 14.6772C105.24 15.0492 105.616 15.2352 106.088 15.2352C106.511 15.2352 106.85 15.0804 107.107 14.7696C107.355 14.4828 107.477 14.1372 107.477 13.734Z"
              fill="white"/>
          <path
              d="M119.845 13.2444C119.845 14.1144 119.59 14.8272 119.08 15.3864C118.546 15.9612 117.84 16.248 116.955 16.248C116.104 16.248 115.426 15.9732 114.919 15.4212C114.414 14.8704 114.162 14.1756 114.162 13.338C114.162 12.462 114.422 11.7432 114.944 11.1852C115.465 10.6272 116.167 10.3476 117.052 10.3476C117.902 10.3476 118.588 10.6224 119.105 11.1732C119.597 11.7084 119.845 12.3996 119.845 13.2444ZM118.508 13.2852C118.508 12.7632 118.392 12.3156 118.162 11.9424C117.89 11.4912 117.506 11.2656 117.004 11.2656C116.487 11.2656 116.093 11.4912 115.821 11.9424C115.59 12.3156 115.475 12.7704 115.475 13.308C115.475 13.83 115.591 14.2776 115.821 14.6508C116.101 15.102 116.489 15.3276 116.992 15.3276C117.484 15.3276 117.872 15.0984 118.15 14.6388C118.387 14.2584 118.508 13.8072 118.508 13.2852Z"
              fill="white"/>
          <path
              d="M126.781 16.1196H125.492V12.8796C125.492 11.8812 125.103 11.382 124.322 11.382C123.939 11.382 123.63 11.5188 123.391 11.7936C123.152 12.0684 123.033 12.3924 123.033 12.7632V16.1184H121.742V12.0792C121.742 11.5824 121.727 11.0436 121.696 10.4604H122.829L122.889 11.3448H122.925C123.076 11.07 123.3 10.8432 123.593 10.662C123.944 10.4508 124.334 10.344 124.763 10.344C125.304 10.344 125.754 10.5144 126.112 10.8564C126.559 11.2752 126.781 11.9004 126.781 12.7308V16.1196Z"
              fill="white"/>
          <path
              d="M135.461 11.4048H134.041V14.1528C134.041 14.8512 134.293 15.2004 134.793 15.2004C135.024 15.2004 135.216 15.1812 135.368 15.1416L135.401 16.0956C135.146 16.1892 134.811 16.236 134.399 16.236C133.89 16.236 133.493 16.0848 133.206 15.7824C132.918 15.48 132.776 14.9712 132.776 14.2572V11.4048H131.928V10.4628H132.776V9.42602L134.04 9.05402V10.4616H135.46V11.4048H135.461Z"
              fill="white"/>
          <path
              d="M142.289 16.1196H140.998V12.9036C140.998 11.8896 140.609 11.382 139.83 11.382C139.232 11.382 138.823 11.676 138.599 12.264C138.561 12.3876 138.539 12.5388 138.539 12.7164V16.1184H137.25V7.8672H138.539V11.2764H138.563C138.969 10.656 139.552 10.3464 140.306 10.3464C140.84 10.3464 141.282 10.5168 141.633 10.8588C142.07 11.2848 142.289 11.9184 142.289 12.756V16.1196Z"
              fill="white"/>
          <path
              d="M149.333 13.0236C149.333 13.2492 149.316 13.4388 149.285 13.5936H145.417C145.434 14.1528 145.618 14.5788 145.977 14.874C146.304 15.138 146.726 15.27 147.243 15.27C147.815 15.27 148.337 15.1812 148.807 15.0024L149.009 15.876C148.459 16.1088 147.812 16.2252 147.062 16.2252C146.164 16.2252 145.456 15.9672 144.944 15.4512C144.43 14.9352 144.175 14.2428 144.175 13.374C144.175 12.5208 144.412 11.8104 144.891 11.244C145.391 10.6392 146.066 10.3368 146.919 10.3368C147.754 10.3368 148.388 10.6392 148.816 11.244C149.162 11.724 149.333 12.318 149.333 13.0236ZM148.102 12.6984C148.112 12.3252 148.027 12.0036 147.852 11.7324C147.628 11.3832 147.287 11.208 146.826 11.208C146.405 11.208 146.062 11.3784 145.799 11.7204C145.585 11.9928 145.458 12.318 145.417 12.6984H148.102Z"
              fill="white"/>
          <path
              d="M66.1792 37.8048H63.3842L61.8531 33.114H56.5313L55.0728 37.8048H52.3516L57.6242 21.8352H60.8808L66.1792 37.8048ZM61.3916 31.146L60.0069 26.976C59.8605 26.55 59.586 25.5468 59.1811 23.9676H59.1319C58.9706 24.6468 58.7109 25.65 58.354 26.976L56.994 31.146H61.3916Z"
              fill="white"/>
          <path
              d="M79.7388 31.9056C79.7388 33.864 79.196 35.412 78.1105 36.5484C77.1382 37.56 75.9308 38.0652 74.4895 38.0652C72.9338 38.0652 71.8163 37.5204 71.1357 36.4308H71.0865V42.4968H68.4625V30.0804C68.4625 28.8492 68.4292 27.5856 68.3652 26.2896H70.6729L70.8194 28.1148H70.8686C71.7437 26.7396 73.0717 26.0532 74.8539 26.0532C76.2471 26.0532 77.4102 26.5896 78.3406 27.6636C79.2735 28.7388 79.7388 30.1524 79.7388 31.9056ZM77.0655 31.9992C77.0655 30.8784 76.8071 29.9544 76.2877 29.2272C75.7203 28.4688 74.9585 28.0896 74.0034 28.0896C73.356 28.0896 72.7677 28.3008 72.2422 28.7172C71.7154 29.1372 71.3708 29.6856 71.2095 30.3648C71.1283 30.6816 71.0877 30.9408 71.0877 31.1448V33.0648C71.0877 33.9024 71.3511 34.6092 71.8779 35.1864C72.4046 35.7636 73.0889 36.0516 73.9308 36.0516C74.9191 36.0516 75.6883 35.6796 76.2385 34.938C76.7899 34.1952 77.0655 33.216 77.0655 31.9992Z"
              fill="white"/>
          <path
              d="M93.3225 31.9056C93.3225 33.864 92.7797 35.412 91.693 36.5484C90.7219 37.56 89.5145 38.0652 88.0733 38.0652C86.5176 38.0652 85.4 37.5204 84.7207 36.4308H84.6714V42.4968H82.0474V30.0804C82.0474 28.8492 82.0142 27.5856 81.9502 26.2896H84.2579L84.4044 28.1148H84.4536C85.3274 26.7396 86.6554 26.0532 88.4388 26.0532C89.8308 26.0532 90.9939 26.5896 91.9268 27.6636C92.856 28.7388 93.3225 30.1524 93.3225 31.9056ZM90.6493 31.9992C90.6493 30.8784 90.3896 29.9544 89.8702 29.2272C89.3028 28.4688 88.5434 28.0896 87.5871 28.0896C86.9385 28.0896 86.3514 28.3008 85.8247 28.7172C85.2979 29.1372 84.9545 29.6856 84.7933 30.3648C84.7133 30.6816 84.6714 30.9408 84.6714 31.1448V33.0648C84.6714 33.9024 84.9348 34.6092 85.4591 35.1864C85.9859 35.7624 86.6702 36.0516 87.5145 36.0516C88.5028 36.0516 89.272 35.6796 89.8222 34.938C90.3736 34.1952 90.6493 33.216 90.6493 31.9992Z"
              fill="white"/>
          <path
              d="M108.51 33.3264C108.51 34.6848 108.026 35.79 107.055 36.6432C105.988 37.5756 104.502 38.0412 102.594 38.0412C100.831 38.0412 99.4182 37.71 98.3486 37.0464L98.9566 34.914C100.109 35.5932 101.373 35.934 102.75 35.934C103.738 35.934 104.507 35.7156 105.06 35.2812C105.61 34.8468 105.885 34.2636 105.885 33.5364C105.885 32.8884 105.658 32.3424 105.204 31.8996C104.752 31.4568 103.998 31.0452 102.944 30.6648C100.077 29.622 98.644 28.0944 98.644 26.0856C98.644 24.7728 99.1462 23.6964 100.152 22.8588C101.154 22.02 102.49 21.6012 104.162 21.6012C105.652 21.6012 106.89 21.8544 107.878 22.3596L107.222 24.4452C106.299 23.9556 105.256 23.7108 104.088 23.7108C103.165 23.7108 102.443 23.9328 101.926 24.3744C101.49 24.7692 101.27 25.2504 101.27 25.8204C101.27 26.4516 101.52 26.9736 102.022 27.384C102.459 27.7632 103.253 28.1736 104.405 28.6164C105.814 29.1696 106.85 29.8164 107.515 30.558C108.179 31.2972 108.51 32.2224 108.51 33.3264Z"
              fill="white"/>
          <path
              d="M117.186 28.2096H114.293V33.8004C114.293 35.2224 114.803 35.9328 115.825 35.9328C116.293 35.9328 116.682 35.8932 116.99 35.814L117.063 37.7568C116.546 37.9452 115.865 38.04 115.022 38.04C113.986 38.04 113.176 37.7316 112.591 37.116C112.009 36.4992 111.716 35.4648 111.716 34.0116V28.2072H109.993V26.2872H111.716V24.1788L114.293 23.4204V26.2872H117.186V28.2096Z"
              fill="white"/>
          <path
              d="M130.236 31.9524C130.236 33.7224 129.717 35.1756 128.68 36.312C127.594 37.482 126.151 38.0652 124.353 38.0652C122.62 38.0652 121.24 37.5048 120.211 36.384C119.182 35.2632 118.668 33.8484 118.668 32.1432C118.668 30.3588 119.197 28.8972 120.259 27.7608C121.319 26.6232 122.749 26.0544 124.547 26.0544C126.28 26.0544 127.675 26.6148 128.727 27.7368C129.734 28.8252 130.236 30.2304 130.236 31.9524ZM127.514 32.0352C127.514 30.9732 127.281 30.0624 126.81 29.3028C126.259 28.3836 125.473 27.9252 124.454 27.9252C123.399 27.9252 122.598 28.3848 122.048 29.3028C121.576 30.0636 121.344 30.9888 121.344 32.0832C121.344 33.1452 121.576 34.056 122.048 34.8144C122.615 35.7336 123.408 36.192 124.43 36.192C125.432 36.192 126.219 35.724 126.786 34.7904C127.27 34.0164 127.514 33.096 127.514 32.0352Z"
              fill="white"/>
          <path
              d="M138.765 28.5396C138.505 28.4928 138.228 28.4688 137.938 28.4688C137.015 28.4688 136.301 28.8084 135.799 29.4888C135.362 30.0888 135.143 30.8472 135.143 31.7628V37.8048H132.52L132.545 29.916C132.545 28.5888 132.512 27.3804 132.446 26.2908H134.732L134.828 28.494H134.9C135.177 27.7368 135.614 27.1272 136.212 26.67C136.797 26.2584 137.428 26.0532 138.109 26.0532C138.352 26.0532 138.571 26.07 138.765 26.1V28.5396Z"
              fill="white"/>
          <path
              d="M150.501 31.5024C150.501 31.9608 150.47 32.3472 150.405 32.6628H142.533C142.564 33.8004 142.944 34.6704 143.675 35.2704C144.338 35.8068 145.196 36.0756 146.25 36.0756C147.415 36.0756 148.479 35.8944 149.435 35.5308L149.846 37.3068C148.729 37.782 147.409 38.0184 145.887 38.0184C144.055 38.0184 142.618 37.4928 141.572 36.4428C140.528 35.3928 140.005 33.9828 140.005 32.214C140.005 30.4776 140.491 29.0316 141.465 27.8784C142.484 26.6472 143.861 26.0316 145.594 26.0316C147.296 26.0316 148.585 26.6472 149.46 27.8784C150.153 28.8564 150.501 30.066 150.501 31.5024ZM147.999 30.8388C148.016 30.0804 147.845 29.4252 147.489 28.872C147.035 28.1604 146.337 27.8052 145.398 27.8052C144.54 27.8052 143.842 28.152 143.309 28.848C142.873 29.4012 142.613 30.0648 142.533 30.8376H147.999V30.8388Z"
              fill="white"/>
          <defs>
            <linearGradient id="paint0_linear_307_884" x1="83.0769" y1="48" x2="47.5" y2="1.00333e-06"
                            gradientUnits="userSpaceOnUse">
              <stop stop-color="#5C2482"/>
              <stop offset="1" stop-color="#C42F2D"/>
            </linearGradient>
          </defs>
        </svg>
      </a>
    </div>

    <div class="more-links">
      <p class="hello">Say Hi!</p>
      <a onclick="gtag('event', 'click_btn', {'btn_name': 'mail'})" class="hover-footer-link" href="mailto:hello@inch.health">hello@inch.health</a>
      <a onclick="gtag('event', 'click_btn', {'btn_name': 'Medical AR Showreel'})" class="hover-footer-link" href="https://inch.health/services/medical-vr" target="_blank">Medical AR
        Showreel</a>
      <a onclick="gtag('event', 'click_btn', {'btn_name': 'Privacy Policy'})" class="hover-footer-link" href="https://inch.health/privacy-policy" target="_blank">Privacy Policy</a>
    </div>
    <p class="last-text">SPEECHki©2018-{{ currentYear }}. All rights reserved </p>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "stage5-mob",

  data: () => ({}),

  mounted() {
    window.addEventListener("scroll", this.scrollEvents, false);

  },

  computed: {
    ...mapGetters(['getIsWhiteBg']),
    currentYear() {
      return new Date().getFullYear()
    }
  },

  beforeUnmount() {
    window.removeEventListener("scroll", this.scrollEvents, false);
  },

  methods: {

    ...mapActions(['switchWhiteBg']),

    scrollEvents() {
      if (window.matchMedia("(max-width: 1160px)").matches) {

        if (this.isInViewport(this.$refs.stage5)) {
          this.switchWhiteBg(true)
        } else {
          this.switchWhiteBg(false)
        }
      }
    },

    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
          rect.top <= 0
      );
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/style/styles";

.stage5-mob {
  padding: 110px 20px 0 20px;

  background-color: rgba(255, 255, 255, 0);

  transition: background-color .15s ease-in-out;

  &.white {
    background-color: white;

    .text-wrapper {

      &__line {

        color: #4A4A49;

        span {
          background: linear-gradient(269.56deg, #692779 20.75%, #EA3628 99.8%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;

          mix-blend-mode: normal;
        }
      }
    }

    .btn {
      background: linear-gradient(268.35deg, #E1362E 0.54%, #8D2C63 133.91%);
      border-color: rgba(255, 255, 255, 0);

      svg {
        path {
          fill-opacity: 1;
        }
      }

      p {
        color: white;
      }
    }

    .text {
      color: #4A4A49;

      b {
        color: #4A4A49;
      }

      .brand-link {
        color: #4A4A49;
        text-decoration: none;
        transition: color .2s ease;

        &:hover {
          color: #8E2959;
          text-decoration: underline;
        }
      }
    }

    .more-links {


      .hello {
        color: #4A4A49;
      }

      a {
        color: #8E2959;

        &:before {
          content: '';
          width: 100%;
          height: 1px;
          background: #8E2959;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;

          transition: opacity .2s ease;
        }
      }
    }

    .last-text {
      color: #4A4A49;
    }
  }

  .text-wrapper {

    @media screen and (max-width: 1024px) {
      max-width: 315px;
      width: 100%;

      margin: 0 auto;
    }

    @media screen and (max-width: 570px) {
      max-width: 100%;
    }

    &__line {
      font-size: 56px;
      line-height: 48px;

      text-transform: uppercase;
      display: block;

      color: rgba(255, 255, 255, 0.6);
      font-family: $thin;

      @media screen and (max-width: 370px) {
        font-size: 48px;
        line-height: 42px;
      }

      &.m-l {
        margin-left: 23px;
      }

      &.icon {
        display: flex;
        align-items: center;
      }

      span {
        font-family: $ELightI;
        font-style: italic;
        color: white;
      }

      img {
        width: 42px;
        height: auto;
        display: inline-block;
        margin-left: 10px;
      }
    }
  }

  .btn {
    width: 210px;
    padding: 22px 10px;

    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;

    margin: 0 auto;
    margin-top: 66px;
    margin-bottom: 76px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 60px;

    svg {
      margin-left: 12px;
    }

    p {
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      line-height: 24px;
      font-family: $reg;
      text-transform: uppercase;
    }
  }

  .text {
    color: rgba(255, 255, 255, 0.6);
    font-size: 18px;
    line-height: 22px;
    text-align: justify;
    margin-bottom: 20px;
    font-family: $light;

    b {
      font-family: $bold;
      color: white;
    }

    .brand-link {
      color: white;
      font-family: $bold;
      text-decoration: none;
      transition: color .2s ease;

      &:hover {
        text-decoration: underline;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .app-btn-wrapper {
    display: flex;
    align-items: center;
    margin-top: 33px;

    a {
      margin-right: 10px;
      text-decoration: navajowhite;

      @media screen and (max-width: 425px) {
        max-width: 50%;
        width: 100%;
      }

      &:last-child {
        margin-right: 0;
      }
    }

    svg {
      max-width: 100%;
      width: 100%;
      height: auto;
      display: block;

    }
  }

  .more-links {
    margin-top: 43px;
    display: inline-flex;
    flex-direction: column;

    .hello {
      font-size: 15px;
      line-height: 18px;
      /* identical to box height */

      display: flex;
      align-items: center;

      color: rgba(255, 255, 255, 0.6);
      font-family: $light;
    }

    a {
      width: max-content;
      font-size: 15px;
      line-height: 24px;
      /* identical to box height, or 160% */
      display: inline-block;

      text-decoration-line: underline;

      color: rgba(255, 255, 255, 0.6);
      font-family: $light;
      margin-bottom: 20px;

      &:before {
        content: '';
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.6);
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        transition: opacity .2s ease;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .last-text {
    margin-top: 40px;

    color: rgba(255, 255, 255, 0.6);
    font-size: 15px;
    line-height: 18px;
    font-family: $light;
    padding-bottom: 100px;
  }
}

</style>
